import React from "react";
import { Button, Box } from "@mui/material";

const StepperNavigation = ({
  activeStep,
  setActiveStep,
  isSubmitting,
  handleSubmit,
  totalSteps,
  turnstileToken, // Explicitly receive turnstileToken
  // Optional: Add a prop like 'isCurrentStepValid' if you want to validate before 'Next'
  // isCurrentStepValid,
}) => {
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    // Optional: Add validation check here before advancing
    // if (!isCurrentStepValid) {
    //   // Optionally show a snackbar or highlight invalid fields
    //   return;
    // }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const isLastStep = activeStep === totalSteps - 1;

  const handleSubmitClick = (e) => {
    // The console log can be removed in production, but helpful for debugging
    console.log(
      "Submit button clicked in navigation. Turnstile token present:",
      !!turnstileToken
    );
    handleSubmit(e); // Call the handleSubmit function passed from the parent
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
      <Button disabled={activeStep === 0 || isSubmitting} onClick={handleBack}>
        Back
      </Button>
      <Box sx={{ flex: "1 1 auto" }} /> {/* This pushes buttons to ends */}
      {isLastStep ? (
        <Button
          variant="contained"
          onClick={handleSubmitClick}
          disabled={isSubmitting || !turnstileToken} // Disable if submitting or Turnstile token is missing
          sx={{
            // Visual feedback for disabled state when Turnstile token is missing
            opacity: !turnstileToken ? 0.6 : 1,
            // You might want to remove these background color overrides if the default disabled styling is sufficient
            // backgroundColor: turnstileToken ? undefined : 'grey.400',
            // '&:hover': {
            //   backgroundColor: turnstileToken ? undefined : 'grey.400',
            // },
          }}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={handleNext}
          disabled={
            isSubmitting
            // Optional: Disable 'Next' if current step is invalid
            // || !isCurrentStepValid
          }
        >
          Next
        </Button>
      )}
    </Box>
  );
};

export default StepperNavigation;
